import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import Home from './components/home/Home';
import StoreWrapper from './components/standalone/StoreWrapper';
import HefestoToJsonWrapper from './components/codeEditor/HefestoToJsonWrapper';
import { AuthContext } from './context/AuthContext';

export default function AppRouter() {
	const { userInfo } = React.useContext(AuthContext);

	return (
		<BrowserRouter>
			<Routes>
				<Route path="/" element={<Home userInfo={userInfo} />} />
				<Route path="/experimental/:viewId" element={<StoreWrapper userInfo={userInfo} sharedRedux={true} />} />
				<Route path="/builder/:viewId" element={<StoreWrapper userInfo={userInfo} />} />
				<Route path="/templates/" element={<HefestoToJsonWrapper />} />
			</Routes>
		</BrowserRouter>
	);
}
